export default {
  install(Vue) {

    let serverDate = null
    let dateDelta = 0

    function reloadServerTime() {
      Vue.prototype.$PfxBackendApi.getServerTime()
        .then(res => {
          const browserClock = new Date().getTime()
          console.log('getServerTime res', res)
          const newServerDate = res.data.now
          serverDate = newServerDate || serverDate || new Date().getTime()
          dateDelta = serverDate - browserClock
          console.debug('serverDate', serverDate, new Date(serverDate))
          console.debug('browserClock', new Date(browserClock))
          console.debug('dateDelta', dateDelta)
          console.log('calculated now', new Date(browserClock + dateDelta))
          setTimeout(reloadServerTime, 120000) // resync every 2 min
        })
        .catch(err => {
          console.error('getServerTime err', err)
          serverDate = new Date().getTime()
          dateDelta = 0
          setTimeout(reloadServerTime, 10000) // retry after a 10 sec
        })
    }
    reloadServerTime()

    Vue.PfxUtils = Vue.prototype.$PfxUtils = {

      currentDate() {
        if (serverDate) {
          const browserClock = new Date().getTime()
          return new Date(browserClock + dateDelta)
        } else {
          // serverDate not yet available, rely on browser
          return new Date()
        }
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/PfxUtilsPlugin.js